'use client';

import Script from 'next/script'

export default function GoogleEventOfertaComponent({perfil}){
  //logger.log('GoogleAnalitycs: ', GA_MEASUREMENT_ID);
    return (
        <>
          <Script id="pageEventDetail" strategy="afterInteractive"
              // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
              dangerouslySetInnerHTML={{
              __html: `
                  window.dataLayer = window.dataLayer || [];
                  window.offertEvent = (perfil, action) => {
                      dataLayer.push({
                            event: 'oferta_empleo',
                            oferta_experiencia: 'Bolsas',  
                            oferta_pais: 'Espana',  
                            oferta_perfil: perfil, 
                            fecha_publicación: '', // Se deja vacío por ahora
                            nombre_oferta: perfil,
                            category: 'Formularios',
                            action: action
                        });
                    };
                window.offertEvent('${perfil}', 'acceso'); 
              `,
              }}
          />
          {/*<div id="pageEvent"*/}
          {/*    dangerouslySetInnerHTML={{*/}
          {/*      __html: `*/}
          {/*      <script type="text/javascript">*/}
          {/*        window.dataLayer = window.dataLayer || [];*/}
          {/*        window.offertEvent = (perfil, action) => {*/}
          {/*            dataLayer.push({*/}
          {/*                  event: 'oferta_empleo',*/}
          {/*                  oferta_experiencia: 'Bolsas',  */}
          {/*                  oferta_pais: 'Espana',  */}
          {/*                  oferta_perfil: perfil, */}
          {/*                  fecha_publicación: '', // Se deja vacío por ahora*/}
          {/*                  nombre_oferta: perfil,*/}
          {/*                  category: 'Formularios',*/}
          {/*                  action: action*/}
          {/*              });*/}
          {/*          };*/}
          {/*      window.offertEvent('${perfil}', 'acceso'); */}
          {/*     </script>`*/}
          {/*}}></div>*/}
        </>
)}